import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import gS from "./generalstyle.module.css";
import { useFormatter } from "../../../util/formatter";
import { set } from "lodash";

const GeneralSummary = (props) => {
	const [rawData, setRawData] = useState([]);
	const [totalCapacity, setTotalCapacity] = useState("0 kWh");
	const [finalExpectedProd, setFinalExpectedProd] = useState("0 kWh");
	const [totalProd, setTotalProd] = useState("0 kWh");
	const [otherLoss, setTotalOtherLoss] = useState("0 kWh");

	const calculateSum = (array) => {
		const sum = array.reduce((partialSum, a) => {
			return Number(partialSum + a);
		}, 0);

		return sum;
	};

	const wattUnit = (num_in_kwh) => {
		if (num_in_kwh / 1000 >= 1) {
			return `${Number(parseFloat(num_in_kwh / 1000).toFixed(3))} MWh`;	
		} else {
			return `${Number(parseFloat(num_in_kwh).toFixed(3))} kWh`;	
		}
	}

	const processRawData = (data) => {
		const _totalCapacity = calculateSum(data.map((d) => d.capacity));
		const _capacityUnit = wattUnit(_totalCapacity);
		setTotalCapacity(`${_capacityUnit}`);

		const _finalExpected = calculateSum(data.map((d) => d.finalExpCor));
		setFinalExpectedProd(`${_finalExpected}`);

		const _totalProd = calculateSum(data.map((d) => d.actualProd));
		const _prodUni = wattUnit(_totalProd);
		setTotalProd(`${_prodUni}`);

		const _totalLoss = calculateSum(data.map((d) => d.other_loss_PR));
		setTotalOtherLoss(`${_totalLoss}`);
	};
	
	useEffect(() => {
		setRawData(props.data);
		if (props.data.length > 0) {
			processRawData(props.data);
		} else {
			setTotalCapacity("0 kWh");
			setFinalExpectedProd("0 kWh");
			setTotalProd("0 kWh");
			setTotalOtherLoss("0 kWh");
		}
	}, [props]);

	return (
		<>
			<div className={gS.leftToMiddle}>
				<Row>
					<Col md={6}>Number of Site reporting/ invoicing</Col>
					<Col md={3}>{rawData.length}</Col>
					<Col md={3}>projects</Col>
				</Row>
				<Row>
					<Col md={6}>Total capacity reporting/ invoicing</Col>
					<Col md={3}>{totalCapacity.split(" ")[0]}</Col>
					<Col md={3}>{totalCapacity.split(" ")[1]}</Col>
				</Row>
				<Row>
					<Col md={6} className={gS.tooltip}>Final expected <span className={gS["tooltiptext"]}>(E Grid (MWh)) * (100 - TA Loss% - GA loss% - Other Losses% -  Unused % selected month) / (Asbuilt PVsyst Yield) * Net Yield including Unused</span></Col>
					<Col md={3}>{finalExpectedProd.split(" ")[0]}</Col>
					<Col md={3}>MWh</Col>
				</Row>
				<Row>
					<Col md={6}>Total actual production</Col>
					<Col md={3}>{totalProd.split(" ")[0]}</Col>
					<Col md={3}>{totalProd.split(" ")[1]}</Col>
				</Row>
				<Row>
					<Col md={6} className={gS.tooltip}>Other loss due to performance issue<span className={gS["tooltiptext"]}>Final expected - Actual Production</span></Col>
					<Col md={3}>{parseFloat(otherLoss).toFixed(3)}</Col>
					<Col md={3}>MWh</Col>
				</Row>
			</div>
		</>
	);
};
export default GeneralSummary;